import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatTableDataSource,
  MatDialog,
  MatPaginator,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-invoice-pr-mngt",
  templateUrl: "./invoice-pr-mngt.component.html",
  styleUrls: ["./invoice-pr-mngt.component.scss"],
})
export class InvoicePrMngtComponent implements OnInit {
  iframeDisplayedColumns: string[] = [
    "Iframe",
    "Commission",
    "AgentCommission",
    "Actions",
  ];
  operatorId = "";
  operator = new MatTableDataSource();
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.operatorId = params["operatorId"];
      console.log("qwertyujk", this.operatorId);
    });
    this.getOperatorComm();
  }

  getOperatorComm() {
    try {
      this.appService.getOPCommissionDocs(this.operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operator = new MatTableDataSource<any>(res.docs[0].commissions);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  goBack = () => {
    this.location.back();
  };

  addCommission = () => {
    let dialogRef = this.dialog.open(CreateIframeCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Add Iframe Commission",
        add: true,
        operatorId: this.operatorId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOperatorComm();
      }
    });
  };

  editCommission = (element) => {
    let dialogRef = this.dialog.open(CreateIframeCommission, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        title: "Edit Iframe Commission",
        add: false,
        iframe: element.iframe,
        commission: element.opCommission,
        agentCommission: element.agentCommission,
        operatorId: this.operatorId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOperatorComm();
      }
    });
  };
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./add-iframe-commission.html",
  styleUrls: ["./invoice-pr-mngt.component.scss"],
})
export class CreateIframeCommission {
  iframecommission: FormGroup;
  selected = new FormControl();
  dropdownSettings: any = {};
  operatorData = ["EXCHANGE", "SPORTSBOOK", "PREMIUM", "VIRTUALS"];

  constructor(
    private appService: AppService,
    public dialogRef: MatDialogRef<CreateIframeCommission>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public Data: any
  ) {}

  data = this.Data;
  check = !this.data.add;

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };

    this.iframecommission = new FormGroup({
      iframe: new FormControl([this.data.iframe], Validators.required),
      commission: new FormControl(this.data.commission, Validators.required),
      agentCommission: new FormControl(
        this.data.agentCommission,
        Validators.required
      ),
    });
  }

  confirm() {
    const payload = {
      operatorId: this.data.operatorId,
      iframe: this.iframecommission.value.iframe[0],
      commission: this.iframecommission.value.commission,
      agentCommission: this.iframecommission.value.agentCommission,
    };
    if (this.data.add) {
      try {
        this.appService.createIframeCommission(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.dialogRef.close();
          }
        });
      } catch (err) {}
    } else {
      try {
        this.appService.updateIframeCommission(payload).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.dialogRef.close(true);
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.dialogRef.close();
          }
        });
      } catch (err) {}
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
